let setLoaderState;

export const loaderService = {
  register: (setStateFunction) => {
    setLoaderState = setStateFunction;
  },
  showLoader: () => {
    if (setLoaderState) setLoaderState(true);
  },
  hideLoader: () => {
    if (setLoaderState) setLoaderState(false);
  },
};
